export const HttpStatusCodes = {
  ACCEPTED: 202,
  BAD_GATEWAY: 502,
  BAD_REQUEST: 400,
  FORBIDDEN: 403,
  GATEWAY_TIMEOUT: 504,
  METHOD_NOT_ALLOWED: 405,
  NETWORK_AUTHENTICATION_REQUIRED: 511,
  NOT_FOUND: 404,
  NOT_IMPLEMENTED: 501,
  OK: 200,
  PROCESSING: 102,
  REQUEST_TIMEOUT: 408,
  SERVICE_UNAVAILABLE: 503,
  UNAUTHORIZED: 401,
  TEMPORARY_REDIRECT: 307,
  SERVER_ERROR: 500,
};
